export default __webpack_public_path__ + "img/ciPgNiSU.b79f293e.svg";